import React, { createContext, useState, useContext, useEffect } from 'react';
import { theme as antTheme } from 'antd';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [primaryColor, setPrimaryColor] = useState('#2563EB');
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [borderRadius, setBorderRadius] = useState(8);

  // Load from local storage on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('appTheme');
    if (savedTheme) {
      const { primaryColor, isDarkMode, borderRadius } = JSON.parse(savedTheme);
      setPrimaryColor(primaryColor || '#2563EB');
      setIsDarkMode(isDarkMode || false);
      setBorderRadius(borderRadius || 8);
    }
  }, []);

  // Save to local storage on change
  useEffect(() => {
    localStorage.setItem('appTheme', JSON.stringify({ primaryColor, isDarkMode, borderRadius }));
  }, [primaryColor, isDarkMode, borderRadius]);

  const themeConfig = {
    token: {
      colorPrimary: primaryColor,
      borderRadius: borderRadius,
      fontFamily: "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
      colorLink: primaryColor,
      colorSuccess: '#059669',
      colorError: '#DC2626',
      colorWarning: '#D97706',
      colorTextBase: '#0F172A',
    },
    components: {
      Card: {
        boxShadowTertiary: '0 1px 3px rgba(0,0,0,0.05)',
      },
      Button: {
        fontWeight: 600,
      }
    },
    algorithm: isDarkMode ? antTheme.darkAlgorithm : antTheme.defaultAlgorithm,
  };

  return (
    <ThemeContext.Provider value={{ 
      primaryColor, 
      setPrimaryColor, 
      isDarkMode, 
      setIsDarkMode, 
      borderRadius, 
      setBorderRadius,
      themeConfig 
    }}>
      {children}
    </ThemeContext.Provider>
  );
};
